
function disable_mouse_wheel_number_input( options ){
    // disable scroll on nubmers
    document.addEventListener("mousewheel", function(event){
        if(document.activeElement.type === "number"){
            document.activeElement.blur();
        }
      }, {'passive' : true });  
}